import { Component, Inject, Renderer2 } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { EncrDecrService } from '@mysrc/app/Providers/EncrDecrService';
import { CommonService } from '../../services/commonservice';
import { CommonModule } from '@angular/common';
import { ColDef } from 'ag-grid-community';
import { HttpClient } from '@angular/common/http';
import { OKTA_AUTH } from '@okta/okta-angular';
import OktaAuth from '@okta/okta-auth-js';
import { BaseHttpReqRespService } from '@mysrc/app/modules/fwcore/services';

// Import ISG Shared Components
import { IsgGridComponent } from '@mysrc/app/shared/components/isg-grid';
import { IsgGridConfig } from '@mysrc/app/shared/models/grid-config.model';

@Component({
  selector: 'questionSearch',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, IsgGridComponent],
  templateUrl: './page-question-search.component.html',
  styleUrl: './page-question-search.component.scss',
  providers: [CommonService]

})
export class PageQuestionSearchComponent extends BaseHttpReqRespService {

  success: boolean = false;
  isExpanded = false;
  public mainQuestionList!: mainQuestion[];
  public gridQuestionList!: mainQuestion[];
  myAppUrl: any;
  public questionsToDelete: string[] = [];
  //public _getMainQuestionListUrl: string = 'Question/GetMainQuestionList/';
  public _getAllQuestionListUrl: string = '/Question/GetAllQuestionList/';
  public _deleteUrl: string = '/Question/DeleteQuestions/';
  errorMessage: any;
  public questionReference!: string;
  public question!: string;
  successOrFailureMessage: string = '';
  public _getQuestionCategoryUrl: string = '/Question/GetQuestionCategoryList/';
  public questionCategoryList: questionCategory[] = [];
  public questionCategoryId: number = 0;
  questionCategoryForm!: FormGroup;
  public fromPage: string = 'Search';
  public searchQuestionCategoryId: number = 0;
  public baseUrl = '';

  // ISG Grid Configuration
  gridConfig: Partial<IsgGridConfig> = {
    height: '400px',
    pagination: true,
    pageSize: 10,
    rowSelection: 'multiple',
    autoSizeColumns: true
  };

  constructor(http: HttpClient
    , @Inject(OKTA_AUTH) private oauth: OktaAuth
    , private EncrDecr: EncrDecrService
    , private commonService: CommonService
    , private route: ActivatedRoute
    , private renderer: Renderer2
    , private formBuilder: FormBuilder
    , private _router: Router
    , @Inject('CONFIG_SETTINGS') configSettings: any) {
    super(http, oauth);
    const genSettings = configSettings[<any>'general'];
    this.baseUrl = genSettings[<any>'adminApiUrl'];
    //this.apiKey = genSettings[<any>'apiKey'];
    this.myAppUrl = this.baseUrl;
  }



ngOnInit() {

  //this.route.params.subscribe(params => {
  //  this.searchQuestionCategoryId = params['searchQuestionCategoryId'];
  //});
  let tmpSearchQuestionCategoryId = this.route.snapshot.queryParams["searchQuestionCategoryId"];
  if (tmpSearchQuestionCategoryId != null && tmpSearchQuestionCategoryId != "") {
    this.searchQuestionCategoryId = Number(tmpSearchQuestionCategoryId);
  }
  else {
    this.searchQuestionCategoryId = 0
  }
  //this.questionReference = this.route.snapshot.queryParams["questionReference"];
  //this.question = this.route.snapshot.queryParams["question"];

  this.questionCategoryForm = this.formBuilder.group({
    'questionCategoryId': new FormControl(null, null),
    'questionCategoryName': new FormControl(null, null)
  });

  this.getAllQuestionList();
  this.getQuestionCategoryList();

}

//ngAfterViewInit() {
//  if (this.searchQuestionCategoryId > 0) {
//    let tmpQuestionCategoryId = this.searchQuestionCategoryId;
//    //let tmpQuestionList = this.mainQuestionList.filter(x => x.questionCategoryId == this.searchQuestionCategoryId);
//    let tmpQuestionList = this.mainQuestionList.filter(function (x) { return x.questionCategoryId === this.searchQuestionCategoryId; });
//    this.questionCategoryForm.patchValue({
//      questionCategoryId: tmpQuestionCategoryId,
//    });
//    this.gridQuestionList = tmpQuestionList;
//  }
//}

ResetQuesCategoryForm() {
  this.questionCategoryForm.reset();
}

onQuestionCategoryChange() {
  //var model = "?schemaId=" + this.sliderForm.get('schemaId').value;
  let tmpQuestionCategoryId = this.questionCategoryForm.get('questionCategoryId')?.value;
  let tmpQuestionList = this.mainQuestionList.filter(x => x.questionCategoryId == tmpQuestionCategoryId);
  this.questionCategoryForm.patchValue({
    questionCategoryId: tmpQuestionCategoryId,
  });
  this.gridQuestionList = tmpQuestionList;
  this.searchQuestionCategoryId = tmpQuestionCategoryId;

}

  getQuestionCategoryList() {
  this.commonService.httpGet("", this.myAppUrl + this._getQuestionCategoryUrl).subscribe(result => {
    this.questionCategoryList = result;
  }, error => console.error(error));

}

  getAllQuestionList() {
  let workspaceId = this.EncrDecr.get(localStorage.getItem('workspaceId') ?? '');
  this.commonService.httpGet("", this.myAppUrl + this._getAllQuestionListUrl +  workspaceId).subscribe(result => {
    this.mainQuestionList = result;
    this.gridQuestionList = result;
  });
}
BackUrl() {
  this._router.navigate(['/question']);
}
onFolderGridReady(params: any) {
  params.api.sizeColumnsToFit();
}
columnDefs: ColDef[] = [
  { headerName: 'QuestionId', field: 'questionReference', hide: true },
  { headerName: 'QuestionCategoryName', field: 'questionCategoryName', hide: true },
  { headerName: 'Preview', field: 'value', width: 200, cellRenderer: this.PreviewQuestionCellRenderer.bind(this), resizable: true },
  { headerName: 'Question Text', field: 'question', width: 600, resizable: true },
  { headerName: 'Type', field: 'questionType', width: 350, resizable: true },
  { headerName: 'Category', field: 'questionCategoryName', width: 350, resizable: true },
  { headerName: 'Folder', field: 'folderName', width: 350, resizable: true }
];

PreviewQuestionCellRenderer(params: any) {
  const eSpan = this.renderer.createElement('a');
  const ielement = this.renderer.createElement('i');
  this.renderer.appendChild(eSpan, ielement);
  this.renderer.setAttribute(eSpan, 'class', 'fa  fa-eye anchor-cursor');
  var questionReference = params.data.questionReference;
  var question = params.data.question;
  this.renderer.listen(eSpan, 'click', () => {
    this._router.navigate(['/previewquestion'], { queryParams: { questionId: questionReference, folderId: 0, folderName: "", fromModule: this.fromPage, searchQuestionCategoryId: this.searchQuestionCategoryId } });
  });
  return eSpan;

}

onRowChecked(params: any) {
  if (params.node.selected) {
    this.questionsToDelete.push(params.data.questionReference + '~' + params.data.questionType);
  }
  else {
    var index = this.questionsToDelete.indexOf(params.data.questionReference + '~' + params.data.questionType);
    if (index !== -1) this.questionsToDelete.splice(index, 1);
  }
}
deleteQuestions() {
  let concatenated = '';
  for (var i = 0; i < this.questionsToDelete.length; i++) {
    concatenated = concatenated + this.questionsToDelete[i] + ",";
  }
  if (concatenated == '') return '';
  else {
    var model = "?questionIdList=" + concatenated;

    this.commonService.httpGet("", this.myAppUrl + this._deleteUrl + model).subscribe(result => {
      if (result.deletedStatus.toLowerCase() == "yes") {
        this.successOrFailureMessage = "Question/Folder Deleted Successfully";
      }
      else if (result.deletedStatus.toLowerCase() == "no") {
        this.successOrFailureMessage = "Cannot delete Question/Folder because there may be some Survey/Section dependency. ";
      }
      else {
        this.successOrFailureMessage = "Error occurred while deleting an question from the repository";
      }
      this.messageTimeout();
      //this.getMainQuestionList();
      this.getAllQuestionList();
      this.questionsToDelete = [];
    }, error => console.error(error));

  }
  return '';

}
messageTimeout() {
  window.setTimeout(() => {
    this.successOrFailureMessage = '';
  }, 3200);
}
}

interface mainQuestion {
  questionReference: string,
  description: string;
  questionTypeId: string,
  questionCategoryId: number,
  questionCategoryName: string,
  folderId: number,
  folderName: string
}

interface questionCategory {
  questionCategoryId: number;
  questionCategoryName: string;
}

